const BASE = process.env.REACT_APP_API_URL ?? 'https://simplemcnetwork.net/api/router.php';

const api = async (usedFunction, dataSend = {}) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    try {
        const response = await fetch(BASE, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            signal: controller.signal,
            body: JSON.stringify({
                function: usedFunction,
                data: dataSend,
                auth: localStorage.getItem('admin_token') || ''
            }),
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
            const errText = await response.text();
            try {
                const errJson = JSON.parse(errText);
                return { isSuccess: false, message: errJson.message || 'Error', data: null };
            } catch (e) {
                return { isSuccess: false, message: `Server error: ${response.status}`, data: null };
            }
        }

        const result = await response.json();
        const { success, message, data, ...rest } = result;
        return {
            isSuccess: success,
            message: message ?? null,
            data: data ?? (Object.keys(rest).length > 0 ? rest : null),
        };
    } catch (error) {
        clearTimeout(timeoutId);
        if (error.name === 'AbortError') {
            return { isSuccess: false, message: 'Request timed out (server not responding)', data: null };
        }
        return { isSuccess: false, message: error.message, data: null };
    }
};

export default api;